module.exports = __webpack_public_path__ + "static/media/phone-chs.c5914590.png";